import { writable } from "svelte/store"

/**
 * @typedef {Object} Item - contain id and name of the template
 * @type {Object}
 * @property {String} id - MongoDB id of the template
 * @property {String} name - name of the template
 * @property {String} description - description of the template
 * @property {String} created - when the template created
 * @property {String} src - email image url to be shown in file template selection carousel
 * @property {String} uri - file image url to be shown in file template selection carousel
 *
 */

/**
 * @typedef {Object} TemplatesList - contain templates list
 * @type {Object}
 * @property {Boolean} emptyInput - to check if input field is empty
 * @property {Boolean} showModal - flip to show metadata preview modal
 * @property {Boolean} showCarousel - flip to show new document template create carousel
 * @property {Boolean} showDelete - flip to show delete modal
 * @property {String} deleteID - holds ID of template to be deleted
 * @property {Array<Item>} document - list of document templates
 * @property {Array<Item>} email - list of email templates
 * @property {Array<Item>} preDefinedEmail - list of user defined email templates
 * @property {Array<Item>} file - list of file templates
 * @property {Array<Item>} userDefinedFile - list of user defined file templates
 */

/**
 * @type {import("svelte/store").Writable<TemplatesList>}
 */
const TemplatesList = writable({
  disabled: false,
  showModal: false,
  showCarousel: false,
  showDelete: false,
  deleteID: null,
  document: [],
  email: [],
  preDefinedEmail: [
    // {
    //   name: "Dont Delete",
    //   id: "6467250dce6693bca8292ec8",
    //   created: "2021-03-13T11:15:32.436Z",
    //   src: "assets/certificates/email1.jpg",
    // },
    // {
    //   name: "Dont Delete",
    //   id: "6467250dce6693bca8292ec8",
    //   created: "2022-03-13T11:15:32.436Z",
    //   src: "assets/certificates/email2.jpg",
    // },
    // {
    //   name: "Dont Delete",
    //   id: "6467250dce6693bca8292ec8",
    //   created: "2020-03-13T11:15:32.436Z",
    //   src: "assets/certificates/email3.jpg",
    // },
    // {
    //   name: "Dont Delete",
    //   id: "6467250dce6693bca8292ec8",
    //   created: "2019-03-13T11:15:32.436Z",
    //   src: "assets/certificates/email4.jpg",
    // },
    // {
    //   name: "Dont Delete",
    //   id: "6467250dce6693bca8292ec8",
    //   created: "2019-03-13T11:15:32.436Z",
    //   src: "assets/certificates/email5.jpg",
    // },
  ],
  file: [],
  userDefinedFile: [
    // {
    //   name: "preDefinedFile 1",
    //   id: "648b0d5a696d27f074338718",
    //   uri: "assets/certificates/file1.jpeg",
    // },
    // {
    //   name: "preDefinedFile 2",
    //   id: "648b0d5a696d27f074338718",
    //   uri: "assets/certificates/file2.jpeg",
    // },
    // {
    //   name: "preDefinedFile 3",
    //   id: "648b0d5a696d27f074338718",
    //   uri: "assets/certificates/file5.jpeg",
    // },
    // {
    //   name: "preDefinedFile 4",
    //   id: "648b0d5a696d27f074338718",
    //   uri: "assets/certificates/file3.jpeg",
    // },
    // {
    //   name: "preDefinedFile 5",
    //   id: "648b0d5a696d27f074338718",
    //   uri: "assets/certificates/file4.jpeg",
    // },
  ],
})
export default TemplatesList
